import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      crypKey: "A",
    };
  },

  methods: {
    cloneObject(obj) {
      return JSON.parse(JSON.stringify(obj));
      //return Object.assign({}, obj);
    },

    isEmptyObject(obj) {
      if (obj == null) return true;
      else return Object.keys(obj).length === 0;
    },

    ua_isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },

    ua_isIOS() {
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },

    ua_isSafari() {
      if (/Safari/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },

    ua_isChrome() {
      if (/Chrome/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },

    ua_isAppleWebKit() {
      if (/AppleWebKit/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },

    roundNumber(value, precision) {
      //return Number(value.toFixed(precision));
      let p = Math.pow(10, precision);
      return Math.round(value * p) / p;
    },

    getRandomColor() {
      var letters = "0123456789ABCDEF".split("");
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },

    encrypt(data) {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.crypKey).toString();
    },

    decrypt(data) {
      let bytes = CryptoJS.AES.decrypt(data, this.crypKey);
      let s = bytes.toString(CryptoJS.enc.Utf8);
      try {
        return JSON.parse(s);
      } catch (err) {
        return s;
      }
    },

    isValidDate(date) {
      return date instanceof Date && !isNaN(date);
    },

    toDate(date) {
      let n_date = null;
      // if (date == null) n_date = new Date();
      // else
      if (date != null) {
        if (this.isValidDate(date)) n_date = date;
        else if (this.$isSqlTimeFormat(date)) {
          n_date = new Date(date);
          if (!this.isValidDate(n_date)) n_date = new Date(date.replace(/ /g, "T"));
        } else n_date = new Date(date);
      }

      return n_date;
    },

    toLocaleString(date, useStoreTimeZone) {
      let localeString = null;
      try {
        let n_date = this.toDate(date);
        if (n_date != null) {
          let timeZone;
          if (useStoreTimeZone == null || useStoreTimeZone) timeZone = this.$store.getters.storeTimeZone;
          localeString = n_date.toLocaleString(this.$deviceLocale, {
            timeZone: timeZone,
            dateStyle: "short",
            timeStyle: "short",
          });
        }
      } catch (error) {
        console.log(error);
      }

      return localeString;
    },

    toLocaleDateString(date, useStoreTimeZone) {
      let localeString = null;
      try {
        let n_date = this.toDate(date);
        if (n_date != null) {
          let timeZone;
          if (useStoreTimeZone == null || useStoreTimeZone) timeZone = this.$store.getters.storeTimeZone;
          localeString = n_date.toLocaleDateString(this.$deviceLocale, { timeZone: timeZone, dateStyle: "short" });
        }
      } catch (error) {
        console.log(error);
      }

      return localeString;
    },

    // h:m am/pm
    toLocaleTimeString(date, useStoreTimeZone) {
      let localeString = null;
      try {
        let n_date = this.toDate(date);
        if (n_date != null) {
          let timeZone;
          if (useStoreTimeZone == null || useStoreTimeZone) timeZone = this.$store.getters.storeTimeZone;
          localeString = n_date.toLocaleTimeString(this.$deviceLocale, { timeZone: timeZone, timeStyle: "short" });
        }
      } catch (error) {
        console.log(error);
      }

      return localeString;
    },

    // hh:mm am/pm
    toLocaleTime12String(date, useStoreTimeZone) {
      let localeString = null;
      try {
        let n_date = this.toDate(date);
        if (n_date != null) {
          let locale = "en-US";
          let timeZone;
          if (useStoreTimeZone == null || useStoreTimeZone) timeZone = this.$store.getters.storeTimeZone;
          let hh = n_date.toLocaleString(locale, { timeZone: timeZone, hour: "2-digit", hour12: false });
          let mm = n_date.toLocaleString(locale, { timeZone: timeZone, minute: "2-digit" });
          if (hh == "24") hh = "00";

          let midday = false;
          let i_hh = parseInt(hh);
          if (i_hh >= 12) {
            midday = true;
          }
          if (i_hh > 12) {
            hh = (i_hh - 12).toString();
          }
          localeString = hh.padStart(2, "0") + ":" + mm.padStart(2, "0") + " " + (midday ? "pm" : "am");
        }
      } catch (error) {
        console.log(error);
      }

      return localeString;
    },

    // hh:mm
    toLocaleTime24String(date, useStoreTimeZone) {
      let localeString = null;
      try {
        let n_date = this.toDate(date);
        if (n_date != null) {
          let locale = "en-US";
          let timeZone;
          if (useStoreTimeZone == null || useStoreTimeZone) timeZone = this.$store.getters.storeTimeZone;
          let hh = n_date.toLocaleString(locale, { timeZone: timeZone, hour: "2-digit", hour12: false });
          let mm = n_date.toLocaleString(locale, { timeZone: timeZone, minute: "2-digit" });
          if (hh == "24") hh = "00";
          localeString = hh.padStart(2, "0") + ":" + mm.padStart(2, "0");
        }
      } catch (error) {
        console.log(error);
      }

      return localeString;
    },

    toSQLDateString(date) {
      let sqlDate = null;
      let n_date = this.toDate(date);
      if (n_date != null) {
        let locale = "en-US";
        let timeZone = this.$store.getters.storeTimeZone;
        sqlDate =
          n_date.toLocaleString(locale, { timeZone: timeZone, year: "numeric" }) +
          "-" +
          n_date.toLocaleString(locale, { timeZone: timeZone, month: "2-digit" }) +
          "-" +
          n_date.toLocaleString(locale, { timeZone: timeZone, day: "2-digit" });
      }

      return sqlDate;
    },

    toSQLDateTimeString(date) {
      let sqlDate = null;
      let n_date = this.toDate(date);
      if (n_date != null) {
        let locale = "en-US";
        let timeZone = this.$store.getters.storeTimeZone;
        let hh = n_date.toLocaleString(locale, { timeZone: timeZone, hour: "2-digit", hour12: false });
        let mm = n_date.toLocaleString(locale, { timeZone: timeZone, minute: "2-digit" }).padStart(2, "0");
        let ss = n_date.toLocaleString(locale, { timeZone: timeZone, second: "2-digit" }).padStart(2, "0");
        if (hh == "24") hh = "00";
        sqlDate = this.toSQLDateString(date) + " " + hh + ":" + mm + ":" + ss;
      }
      return sqlDate;
    },

    // output hh:mm or hh:mm am/pm
    toTimeString(date, hour12) {
      let stString;
      let n_date = this.toDate(date);
      if (date instanceof Date) {
        let timeZone = this.$store.getters.storeTimeZone;
        let hh = n_date.toLocaleString(this.userLanguage, { timeZone: timeZone, hour: "2-digit", hour12: false });
        let mm = n_date.toLocaleString(this.userLanguage, { timeZone: timeZone, minute: "2-digit" }).padStart(2, "0");
        if (hh == "24") hh = "00";
        if (hour12) {
          let midday = false;
          if (hh >= 12) midday = true;
          if (hh > 12) hh = hh - 12;
          stString = hh + ":" + mm + (midday ? "pm" : "am");
        } else stString = hh + ":" + mm;
      } else {
        stString = date;
      }

      return stString;
    },

    // output hh:mm am/pm
    stringToStandardTimeString(time) {
      if (typeof time != "string" || time.length != 5 || !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time)) return time;
      else {
        let midday = false;
        let hh = time.substr(0, 2);
        let mm = time.substr(3, 2);
        if (hh == "00" && mm == "00") {
          return "Midnight";
        } else if (hh == "12" && mm == "00") {
          return "Noon";
        } else {
          if (hh >= "12") {
            midday = true;
          }
          if (hh > "12") {
            hh = (parseInt(hh) - 12).toString();
          } else {
            hh = parseInt(hh).toString();
          }

          return hh + ":" + mm + (midday ? "pm" : "am");
        }
      }
    },

    toFloat(value) {
      let res = parseFloat(value);
      if (isNaN(res)) {
        res = 0;
      }

      return res;
    },

    readIonicIndexedDb() {
      console.log("Read ionic indexed db");

      let companyCode = this.$store.getters.storeCompanyCode;
      return new Promise((resolve, reject) => {
        let request = window.indexedDB.open("__digidb");
        if (request) {
          request.onsuccess = function() {
            let records = [];
            let db = request.result;

            if (db.objectStoreNames.contains("_ionickv")) {
              let trans = db.transaction(["_ionickv"]);
              trans.oncomplete = () => {
                resolve(records);
              };

              let store = trans.objectStore("_ionickv");
              store.openCursor().onsuccess = e => {
                let cursor = e.target.result;
                if (cursor) {
                  if (cursor.key == "VERIFIED_PHONE_NUMBERS" || cursor.key.includes(companyCode)) {
                    records.push({
                      key: cursor.key,
                      value: cursor.value,
                    });
                  }

                  cursor.continue();
                }
              };
            }
          };

          request.onerror = e => {
            reject(e);
          };
        }
      });
    },
  },
};
